<cac-dialog-layout [title]="'Select Products'" (onSubmit)="onSubmit($event)" submitBtn="Add Products">
    <cac-table [options]="table"></cac-table>
</cac-dialog-layout>
